const module = { name: 'mobile/global/header', exports: {} }; const exports = module.exports;



const AnalyticsEvents = {
    SIDEBAR: 'sidebar',
    HOME: 'home',
    SEARCH: 'search',
    LOCATION: 'location',
    ACCOUNT: 'account',
    MOVIES: 'movies',
    THEATERS: 'theaters',
    FANDANGO_AT_HOME: 'fandango at home',
    FANCLUB: 'fanclub',
}


const Selectors = {
    GLOBAL_HEADER: '.global-header',
    HAMBURGER_MENU: '.js-hamburger-menu',
    HOME_NAV_LINK: '.js-home-nav-link',
    SEARCH_BTN: '.js-global-search-icon',
    LOCATION_BTN: '.js-location-overlay',
    ACCOUNT_NAV_LINK: '.js-account-nav-link',
    MOVIES_NAV_LINK: '.js-movies-nav-link',
    THEATERS_NAV_LINK: '.js-theaters-nav-link',
    AT_HOME_NAV_LINK: '.js-at-home-nav-link',
    FANCLUB_NAV_LINK: '.js-fanclub-nav-link',
}


const Styles = {
    HEADER_SCROLLED: 'global-header--scrolled',
}
function triggerAnalyticsEvent(navItem) {
    const event = {
        event: 'mobile nav clicked',
        navItem,
    };
    window.dataLayer.push(event);
}
function setupClickHandlers() {
    const hamburgerMenuBtn = document.querySelector(Selectors.HAMBURGER_MENU);
    hamburgerMenuBtn?.addEventListener('click', () => {
        triggerAnalyticsEvent(AnalyticsEvents.SIDEBAR);
    });
    const homeNavLinkElement = document.querySelector(Selectors.HOME_NAV_LINK);
    homeNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.HOME);
        window.location = homeNavLinkElement.href;
    });
    const searchBtn = document.querySelector(Selectors.SEARCH_BTN);
    searchBtn?.addEventListener('click', () => {
        triggerAnalyticsEvent(AnalyticsEvents.SEARCH);
    });
    const locationBtn = document.querySelector(Selectors.LOCATION_BTN);
    locationBtn?.addEventListener('click', () => {
        triggerAnalyticsEvent(AnalyticsEvents.LOCATION);
    });
    const accountNavLinkElement = document.querySelector(Selectors.ACCOUNT_NAV_LINK);
    accountNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.ACCOUNT);
        window.location = accountNavLinkElement.href;
    });
    const moviesNavLinkElement = document.querySelector(Selectors.MOVIES_NAV_LINK);
    moviesNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.MOVIES);
        window.location = moviesNavLinkElement.href;
    });
    const theatersNavLinkElement = document.querySelector(Selectors.THEATERS_NAV_LINK);
    theatersNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.THEATERS);
        window.location = theatersNavLinkElement.href;
    });
    const atHomeNavLinkElement = document.querySelector(Selectors.AT_HOME_NAV_LINK);
    atHomeNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.FANDANGO_AT_HOME);
        window.open(atHomeNavLinkElement.href, '_blank');
    });
    const fanClubNavLinkElement = document.querySelector(Selectors.FANCLUB_NAV_LINK);
    fanClubNavLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.FANCLUB);
        window.location = fanClubNavLinkElement.href;
    });
}
function init() {
    const headerEl = document.querySelector(Selectors.GLOBAL_HEADER);
    if (!headerEl) {
        return;
    }
    function updateHeader() {
        const isScrolled = window.scrollY > 0;
        headerEl.classList.toggle(Styles.HEADER_SCROLLED, isScrolled);
    }
    window.addEventListener('scroll', updateHeader);
    updateHeader();
    setupClickHandlers();
}
module.exports = {
    init,
};
export default module.exports;